import { extractList } from '../../utils/response';
import { store } from '../../store';
import { leadsApi } from '../../store/api/leadsApi';

export function normalizeLeadOption(l) {
  if (!l) return null;
  const id = l.id ?? l.uuid;
  return {
    ...l,
    id,
    label: l.name || l.dba_name || l.email || String(id),
  };
}

/**
 * Statuses for call recordings (Active / Deactivate). Tries common model names, then optional name filter.
 */
export async function loadCallRecordStatuses() {
  const models = ['CallRecord', 'call_record', 'Recording', 'CallRecording'];
  for (const model of models) {
    try {
      const res = await store
        .dispatch(
          leadsApi.endpoints.getLeadsStatus.initiate({
            'conditions[model]': model,
            paginate: 0,
          })
        )
        .unwrap();
      const list = extractList(res);
      if (!Array.isArray(list) || !list.length) continue;
      const named = list.filter((s) =>
        /active|deactiv/i.test(String(s?.name ?? s?.title ?? s?.label ?? ''))
      );
      return named.length ? named : list;
    } catch {
      /* try next model */
    }
  }
  try {
    const res = await store
      .dispatch(leadsApi.endpoints.getLeadsStatus.initiate({ paginate: 0 }))
      .unwrap();
    const list = extractList(res);
    if (!Array.isArray(list)) return [];
    const named = list.filter((s) =>
      /active|deactiv/i.test(String(s?.name ?? s?.title ?? s?.label ?? ''))
    );
    return named.length ? named : list;
  } catch {
    return [];
  }
}
